import { useContext, useEffect, useState } from "react";

import PanelRightContent from "../../layouts/mainPanel/PanelRightContent";
import MainPanelHeader from "../../layouts/mainPanelHeader";
import { ReactComponent as MarketIcon } from "../../asset/icons/sidebar/basket.svg";
import { ReactComponent as PlusIcon } from "../../asset/icons/plusIconLarge.svg";
import { ReactComponent as EditIcon } from "../../asset/icons/editIconBlue.svg";
import ItemCart from "./components/ItemCart";
import BasketInput from "./components/BasketInput";

import { ReactComponent as CubeIcon } from "../../asset/icons/cube.svg";
import { ReactComponent as DateIcon } from "../../asset/icons/calender_gray_s.svg";
import { ReactComponent as CoinIcon } from "../../asset/icons/rate_ic.svg";
import { useNavigate, useParams } from "react-router-dom";

import defaultImage from "./../../asset/image/ex_img_3.png";
import dateIcon from "./../../asset/icons/calender_gray_s.svg";
import { Spinner } from "react-bootstrap";

import {
    DELETE_MARKET_PRICE,
    EDIT_MARKET_PRICE,
    GET_MARKET_BASKET,
    GET_MARKET_ITEMS,
    SAVE_MARKET_BASKET,
} from "../../helperData/ApiAddress";
import { del, get, post, put } from "../../controlers/global/ConfigRequest";

import { ToastContext } from "../../component/global/ToastContext";
import { useTranslation } from "react-i18next";

export default function BasketForm() {
    const { id, item } = useParams();
    const history = useNavigate();

    const [volumeFrom, setVolumeFrom] = useState("");
    const [volumeFromErr, setVolumeFromErr] = useState("");

    const [volumeTo, setVolumeTo] = useState("");
    const [volumeToErr, setVolumeToErr] = useState("");

    const [deliverFrom, setDeliverFrom] = useState("");
    const [deliverFromErr, setDeliverFromErr] = useState("");

    const [deliverTo, setDeliverTo] = useState("");
    const [deliverToErr, setDeliverToErr] = useState("");

    const [paymentFrom, setPaymentFrom] = useState("");
    const [paymentFromErr, setPaymentFromErr] = useState("");

    const [paymentTo, setPaymentTo] = useState("");
    const [paymentToErr, setPaymentToErr] = useState("");

    const [price, setPrice] = useState("");
    const [priceErr, setPriceErr] = useState("");

    const [feedCoin, setFeedCoin] = useState("");
    const [feedCoinErr, setFeedCoinErr] = useState("");

    const [formLoader, setFormLoader] = useState(false);
    const [priceDeleteLoader, setPriceDeleteLoader] = useState(false);
    const [priceEditLoader, setPriceEditLoader] = useState(false);

    const [priceList, setPriceList] = useState(undefined);
    const [priceListEditMode, setPriceListEditMode] = useState(false);

    const [editItem, setEditItem] = useState(undefined);

    const [itemBox, setItemBox] = useState(undefined);
    const { t } = useTranslation();
    const show = useContext(ToastContext);

    const getFormInfo = () => {
        get(GET_MARKET_BASKET + id).then((r) => {
            setPriceList(
                r.prices.map((item) => ({
                    id: item.id,
                    volumeFrom: item.volume_start,
                    volumeTo: item.volume_end,
                    deliverFrom: item.delivery_start,
                    deliverTo: item.delivery_end,
                    paymentFrom: item.payment_start,
                    paymentTo: item.payment_end,
                    price: item.price,
                }))
            );
            setEditItem(r.item.id);
            setFeedCoin(r.coin + "");
        });
    };

    const getItemInfo = (id) => {
        get(GET_MARKET_ITEMS + id).then((r) => {
            setItemBox(r);
        });
    };

    const deletePrice = (id, row) => {
        if (id) {
            setPriceDeleteLoader(id);
            del(DELETE_MARKET_PRICE.replace(":id", id))
                .then((r) => {
                    setPriceList(priceList.filter((item) => item.id !== id));
                })
                .finally((_) => {
                    setPriceDeleteLoader(false);
                });
        } else {
            setPriceList(priceList.filter((item, index) => index !== row));
        }
    };

    const goToEdit = (index) => {
        setPriceListEditMode(index);
        const row = priceList.filter((item, ind) => index === ind)[0];
        // console.log(row);
        setVolumeFrom(row.volumeFrom + "");
        setVolumeTo(row.volumeTo + "");
        setDeliverFrom(row.deliverFrom + "");
        setDeliverTo(row.deliverTo + "");
        setPaymentFrom(row.paymentFrom + "");
        setPaymentTo(row.paymentTo + "");
        setPrice(row.price + "");
    };

    useEffect(() => {
        if (id) {
            getFormInfo();
        } else {
            setPriceList([]);
        }
    }, []);

    useEffect(() => {
        if (item) {
            getItemInfo(item);
        } else if (editItem) {
            getItemInfo(editItem);
        }
    }, [editItem, item]);

    const priceListHandle = () => {
        setVolumeFromErr("");
        setVolumeToErr("");
        setDeliverFromErr("");
        setDeliverToErr("");
        setPaymentFromErr("");
        setPaymentToErr("");
        setPriceErr("");

        let hasErr = false;

        if (volumeFrom.trim() === "") {
            setVolumeFromErr(t("Src.Pages.Market.BasketForm.setVolumeFromErr"));
            hasErr = true;
        } else if (!Number.isInteger(volumeFrom.trim() * 1)) {
            setVolumeFromErr(
                t("Src.Pages.Market.BasketForm.setVolumeValidationFromErr")
            );
            hasErr = true;
        }

        if (volumeTo.trim() === "") {
            setVolumeToErr(t("Src.Pages.Market.BasketForm.setVolumeToErr"));
            hasErr = true;
        } else if (!Number.isInteger(volumeTo.trim() * 1)) {
            setVolumeToErr(
                t("Src.Pages.Market.BasketForm.setVolumeValidationToErr")
            );
            hasErr = true;
        }

        if (deliverFrom.trim() === "") {
            setDeliverFromErr(
                t("Src.Pages.Market.BasketForm.setDeliverFromErr")
            );
            hasErr = true;
        } else if (!Number.isInteger(deliverFrom.trim() * 1)) {
            setDeliverFromErr(
                t("Src.Pages.Market.BasketForm.etDeliverFromErr")
            );
            hasErr = true;
        }

        if (deliverTo.trim() === "") {
            setDeliverToErr(t("Src.Pages.Market.BasketForm.setDeliverToErr"));
            hasErr = true;
        } else if (!Number.isInteger(deliverTo.trim() * 1)) {
            setDeliverToErr(
                t("Src.Pages.Market.BasketForm.setDeliverValidationToErr")
            );
            hasErr = true;
        }

        if (paymentFrom.trim() === "") {
            setPaymentFromErr(
                t("Src.Pages.Market.BasketForm.setPaymentFromErr")
            );
            hasErr = true;
        } else if (!Number.isInteger(paymentFrom.trim() * 1)) {
            setPaymentFromErr(
                t("Src.Pages.Market.BasketForm.setPaymentValidationFromErr")
            );
            hasErr = true;
        }

        if (paymentTo.trim() === "") {
            setPaymentToErr(t("Src.Pages.Market.BasketForm.setPaymentToErr"));
            hasErr = true;
        } else if (!Number.isInteger(paymentTo.trim() * 1)) {
            setPaymentToErr(
                t("Src.Pages.Market.BasketForm.setPaymentValidationToErr")
            );
            hasErr = true;
        }

        if (price.trim() === "") {
            setPriceErr(t("Src.Pages.Market.BasketForm.setPriceErr"));
            hasErr = true;
        } else if (!Number.isInteger(price.trim() * 1)) {
            setPriceErr(t("Src.Pages.Market.BasketForm.setPriceValidationErr"));
            hasErr = true;
        }

        if (hasErr) return false;

        if (priceListEditMode !== false) {
            const editPromise = new Promise((resolve, reject) => {
                if (priceList[priceListEditMode].id) {
                    put(
                        EDIT_MARKET_PRICE.replace(
                            ":id",
                            priceList[priceListEditMode].id
                        ),
                        {
                            sale_cart: 1,
                            price: price,
                            volume_start: volumeFrom,
                            volume_end: volumeTo,
                            delivery_start: deliverFrom,
                            delivery_end: deliverTo,
                            payment_start: paymentFrom,
                            payment_end: paymentTo,
                        }
                    ).then((_) => {
                        resolve();
                    });
                } else {
                    resolve();
                }
            });
            editPromise.then((r) => {
                const priceListTemp = [...priceList];
                priceListTemp[priceListEditMode] = {
                    id: priceList[priceListEditMode].id || undefined,
                    volumeFrom,
                    volumeTo,
                    deliverFrom,
                    deliverTo,
                    paymentFrom,
                    paymentTo,
                    price,
                };
                setPriceList(priceListTemp);
                setPriceListEditMode(false);
                setVolumeFrom("");
                setVolumeTo("");
                setDeliverFrom("");
                setDeliverTo("");
                setPaymentFrom("");
                setPaymentTo("");
                setPrice("");
            });
        } else {
            setPriceList([
                ...priceList,
                {
                    volumeFrom,
                    volumeTo,
                    deliverFrom,
                    deliverTo,
                    paymentFrom,
                    paymentTo,
                    price,
                },
            ]);

            setVolumeFrom("");
            setVolumeTo("");
            setDeliverFrom("");
            setDeliverTo("");
            setPaymentFrom("");
            setPaymentTo("");
            setPrice("");
        }
    };

    const sendFormHandle = () => {
        let hasErr = false;

        if (feedCoin.trim() === "") {
            setFeedCoinErr(t("Src.Pages.Market.BasketForm.setFeedCoinErr"));
            hasErr = true;
        } else if (!Number.isInteger(feedCoin.trim() * 1)) {
            setFeedCoinErr(
                t("Src.Pages.Market.BasketForm.setFeedCoinValidationErr")
            );
            hasErr = true;
        }
        if (hasErr) return false;

        setFormLoader(true);
        if (item) {
            post(SAVE_MARKET_BASKET.replace(":id/", ""), {
                item,
                company: window.sessionStorage.getItem("usercompany"),
                coin: feedCoin * 1,
                prices: priceList.map((item) => ({
                    sale_cart: 1,
                    price: item.price,
                    volume_start: item.volumeFrom,
                    volume_end: item.volumeTo,
                    delivery_start: item.deliverFrom,
                    delivery_end: item.deliverTo,
                    payment_start: item.paymentFrom,
                    payment_end: item.paymentTo,
                })),
            })
                .then((r) => {
                    history("/dashboard/market/3");
                })
                .catch((e) => {
                    if (
                        e.response.data.non_field_errors[0] ===
                        "The fields item, company must make a unique set."
                    ) {
                        show(
                            t("Src.Pages.Market.BasketForm.Response.Danger"),
                            "danger"
                        );
                    }
                })
                .finally((_) => {
                    setFormLoader(false);
                });
        } else {
            put(SAVE_MARKET_BASKET.replace(":id", id), {
                item: editItem,
                company: window.sessionStorage.getItem("usercompany"),
                coin: feedCoin * 1,
                prices: priceList
                    .filter((item) => !item.id)
                    .map((item) => ({
                        sale_cart: 1,
                        price: item.price,
                        volume_start: item.volumeFrom,
                        volume_end: item.volumeTo,
                        delivery_start: item.deliverFrom,
                        delivery_end: item.deliverTo,
                        payment_start: item.paymentFrom,
                        payment_end: item.paymentTo,
                    })),
            })
                .then((r) => {
                    history("/dashboard/market/3");
                })
                .finally((_) => {
                    setFormLoader(false);
                });
        }
    };

    return (
        <div className="market-main">
            <MainPanelHeader
                panelType={t("Corpration.Panel.label")}
                panelName={t("SellingCart.Label")}
            />
            <div className="market-content">
                <PanelRightContent>
                    <div className="title">
                        <MarketIcon />
                        <span>{t("Src.Pages.Market.BasketForm.Title")}</span>
                    </div>
                    <div className="basket-form">
                        <div>
                            <BasketInput
                                title={t(
                                    "Src.Pages.Market.BasketForm.BasketInput.VolumeFrom.Title"
                                )}
                                error={volumeFromErr}
                                value={volumeFrom}
                                onChange={(e) => setVolumeFrom(e)}
                                icon={<CubeIcon />}
                                clearErr={(_) => setVolumeFromErr("")}
                            />
                            <BasketInput
                                title={t(
                                    "Src.Pages.Market.BasketForm.BasketInput.VolumeUntil.Title"
                                )}
                                error={volumeToErr}
                                value={volumeTo}
                                onChange={(e) => setVolumeTo(e)}
                                icon={<CubeIcon />}
                                clearErr={(_) => setVolumeToErr("")}
                            />
                            <BasketInput
                                title={t(
                                    "Src.Pages.Market.BasketForm.BasketInput.DeliveryFrom.Title"
                                )}
                                error={deliverFromErr}
                                value={deliverFrom}
                                onChange={(e) => setDeliverFrom(e)}
                                icon={<DateIcon />}
                                clearErr={(_) => setDeliverFromErr("")}
                            />
                            <BasketInput
                                title={t(
                                    "Src.Pages.Market.BasketForm.BasketInput.DeliveryUntil.Title"
                                )}
                                error={deliverToErr}
                                value={deliverTo}
                                onChange={(e) => setDeliverTo(e)}
                                icon={<DateIcon />}
                                clearErr={(_) => setDeliverToErr("")}
                            />
                            <BasketInput
                                title={t(
                                    "Src.Pages.Market.BasketForm.BasketInput.PaymentFrom.Title"
                                )}
                                error={paymentFromErr}
                                value={paymentFrom}
                                onChange={(e) => setPaymentFrom(e)}
                                icon={<DateIcon />}
                                clearErr={(_) => setPaymentFromErr("")}
                            />
                            <BasketInput
                                title={t(
                                    "Src.Pages.Market.BasketForm.BasketInput.PaymentUntil.Title"
                                )}
                                error={paymentToErr}
                                value={paymentTo}
                                onChange={(e) => setPaymentTo(e)}
                                icon={<DateIcon />}
                                clearErr={(_) => setPaymentToErr("")}
                            />
                            <BasketInput
                                title={t(
                                    "Src.Pages.Market.BasketForm.BasketInput.Price.Title"
                                )}
                                error={priceErr}
                                value={price}
                                onChange={(e) => setPrice(e)}
                                icon={<DateIcon />}
                                clearErr={(_) => setPriceErr("")}
                            />
                            <button
                                className="toolbar-btn-primary"
                                onClick={priceListHandle}
                            >
                                {priceListEditMode !== false ? (
                                    <EditIcon />
                                ) : (
                                    <PlusIcon />
                                )}
                            </button>
                            <BasketInput
                                title={t(
                                    "Src.Pages.Market.BasketForm.BasketInput.FeedCoinAmount"
                                )}
                                error={feedCoinErr}
                                value={feedCoin}
                                onChange={(e) => setFeedCoin(e)}
                                icon={<CoinIcon />}
                                clearErr={(_) => setFeedCoinErr("")}
                            />
                            <div className="button-group">
                                <button
                                    className="button primary"
                                    disabled={priceList?.length === 0}
                                    onClick={sendFormHandle}
                                >
                                    {formLoader && (
                                        <div className="spinner-border-con">
                                            <Spinner animation="border" />
                                        </div>
                                    )}
                                    {!formLoader && (
                                        <div>
                                            {item
                                                ? t(
                                                      "Src.Pages.Market.BasketForm.Button.Add"
                                                  )
                                                : t(
                                                      "Src.Pages.Market.BasketForm.Button.Edit"
                                                  )}
                                        </div>
                                    )}
                                </button>
                                <button
                                    className="button delete"
                                    onClick={(_) =>
                                        history("/dashboard/market/3")
                                    }
                                >
                                    {t(
                                        "Src.Pages.Market.BasketForm.Button.Cancel"
                                    )}
                                </button>
                            </div>
                        </div>
                        {itemBox && (
                            <div>
                                <ItemCart
                                    link={itemBox?.id}
                                    score={itemBox?.computed_score}
                                    description={itemBox?.description}
                                    fullDescritpion={true}
                                    name={itemBox?.name}
                                    photo={itemBox?.photo}
                                    priceMin={itemBox?.price_min}
                                    priceMax={itemBox?.price_max}
                                    salersCount={itemBox?.salers_count}
                                />
                            </div>
                        )}
                    </div>
                    <div className="basket-form-table-con">
                        {priceList ? (
                            priceList.length > 0 && (
                                <div className="basket-form-table">
                                    <div className="header">
                                        <div>
                                            {t(
                                                "Src.Pages.Market.BasketForm.Table.RowNumber.Label"
                                            )}
                                        </div>
                                        <div>
                                            {t(
                                                "Src.Pages.Market.BasketForm.Table.VolumeBuy.Label"
                                            )}
                                        </div>
                                        <div>
                                            {t(
                                                "Src.Pages.Market.BasketForm.Table.DeliverTime.Label"
                                            )}
                                        </div>
                                        <div>
                                            {t(
                                                "Src.Pages.Market.BasketForm.Table.TimePayment.Label"
                                            )}
                                        </div>
                                        <div>
                                            {t(
                                                "Src.Pages.Market.BasketForm.Table.Functions.Label"
                                            )}
                                        </div>
                                    </div>
                                    {priceList.map((row, index) => (
                                        <div>
                                            <div>
                                                <img
                                                    className="preview"
                                                    src={defaultImage}
                                                    alt=""
                                                />
                                            </div>
                                            <div>
                                                {row.volumeFrom +
                                                    ` ${t(
                                                        "Src.Pages.Market.BasketForm.to"
                                                    )} ` +
                                                    row.volumeTo}
                                            </div>
                                            <div>
                                                <img src={dateIcon} alt="" />
                                                <span>
                                                    {row.deliverFrom +
                                                        ` ${t(
                                                            "Src.Pages.Market.BasketForm.to"
                                                        )} ` +
                                                        row.deliverTo}{" "}
                                                    {t(
                                                        "Src.Pages.Market.BasketForm.Day"
                                                    )}
                                                </span>
                                            </div>
                                            <div>
                                                <img src={dateIcon} alt="" />
                                                <span>
                                                    {row.paymentFrom +
                                                        ` ${t(
                                                            "Src.Pages.Market.BasketForm.to"
                                                        )} ` +
                                                        row.paymentTo}{" "}
                                                    {t(
                                                        "Src.Pages.Market.BasketForm.Day"
                                                    )}
                                                </span>
                                            </div>
                                            <div>
                                                <button
                                                    className="button primary"
                                                    onClick={(_) =>
                                                        goToEdit(index)
                                                    }
                                                >
                                                    {t(
                                                        "Src.Pages.Market.BasketForm.Button.Edit"
                                                    )}
                                                </button>
                                                <button
                                                    className="button delete"
                                                    onClick={(_) => {
                                                        deletePrice(
                                                            row.id,
                                                            index
                                                        );
                                                    }}
                                                >
                                                    {priceDeleteLoader ===
                                                    row.id ? (
                                                        <div className="spinner-border-con">
                                                            <Spinner animation="border" />
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            {t(
                                                                "Src.Pages.Market.BasketForm.Button.Remove"
                                                            )}
                                                        </div>
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )
                        ) : (
                            <Spinner animation="border" />
                        )}
                    </div>
                </PanelRightContent>
            </div>
        </div>
    );
}
